<template>
  <Dialog
    v-model:visible="visible"
    modal
    rtl
    :closable="false"
    :pt="{
      root: { class: 'welcome-dialog' },
      header: {
        style: { display: 'none' }
      },
      content: {
        style: { padding: 0 }
      }
    }"
    :style="{ width: '90dvw', maxWidth: '500px', height: 'max-content', 'max-height': '90dvh' }"
  >
    <div class="welcome-modal-wrapper relative">
      <!-- Custom Close Button -->
      <i
        class="absolute pi pi-times bg-black bg-opacity-30 p-2 rounded-full text-white top-2 left-2 z-10 cursor-pointer hover:bg-opacity-40 transition-all"
        @click="onClose"
      />

      <!-- Header Section -->
      <div class="w-full bg-gradient-to-br from-purple-100 via-purple-50 to-white pb-4 pt-8 px-6 text-center">
        <h2 class="text-2xl font-medium text-primary-700">
          ברוכים הבאים לטיימאיט!
        </h2>
      </div>

      <!-- Content Section -->
      <div class="flex flex-col items-center px-6 pt-4 pb-6">
        <!-- Intro text -->
        <div class="text-center mb-5">
          <p class="text-gray-700 text-sm leading-relaxed text-pretty">
            הקמנו את טיימאיט כדי לעזור לכם להתמקד במה שחשוב באמת, הלקוחות שלכם. וכדי שתוכלו לעשות זאת בצורה הטובה ביותר אנחנו זמינים עבורכם לכל שאלה.
          </p>
        </div>

        <!-- YouTube Video -->
        <div class="video-container w-full mb-5">
          <div class="relative rounded-xl overflow-hidden shadow-xl" style="padding-bottom: 56.25%; height: 0;">
            <iframe
              :src="videoUrl"
              class="absolute top-0 left-0 w-full h-full"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>

        <!-- Support section -->
        <div class="w-full bg-gray-50 rounded-xl p-4 mb-4">
          <div class="flex items-start gap-3">
            <i class="pi pi-info-circle text-primary-500 text-xl mt-1"></i>
            <div class="flex-1">
              <p class="text-sm text-gray-700 font-medium mb-1">יש שאלות? אנחנו כאן בשבילכם!</p>
              <p class="text-xs text-gray-600">הצוות שלנו זמין לעזור בכל שלב</p>
            </div>
          </div>
        </div>

        <!-- WhatsApp Support Button -->
        <Button
          label="שלחו לנו הודעה בוואטסאפ"
          icon="pi pi-whatsapp"
          class="w-full !bg-[#25D366] !border-[#25D366] hover:!bg-[#1da851] !text-white !py-3 !text-base !font-semibold !rounded-xl shadow-lg hover:shadow-xl transition-all"
          @click="contactSupport"
        />

        <p class="text-xs text-gray-500 text-center mt-3">
          תוכלו תמיד ליצור איתנו קשר דרך תפריט העזרה באפליקציה
        </p>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { sendWhatsApp } from '@torim-app/utils';
import { trackEvent } from '@app/composables/posthog';

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close']);

const visible = ref(props.show);

// YouTube video URL with autoplay disabled
const videoUrl = computed(() =>
  'https://www.youtube.com/embed/LT69-keNmOw?rel=0&modestbranding=1'
);

const contactSupport = () => {
  trackEvent('welcome_modal_whatsapp_clicked');
  sendWhatsApp('972559299380', 'היי, הגעתי דרך האפליקציה ואשמח לעזרה.');
};

const onClose = () => {
  trackEvent('welcome_modal_closed');
  visible.value = false;
  emit('close');
};

// Watch for prop changes
import { watch } from 'vue';
watch(() => props.show, (newVal) => {
  visible.value = newVal;
  if (newVal) trackEvent('welcome_modal_shown');
});
</script>

<style scoped lang="scss">
.welcome-modal-wrapper {
  .video-container {
    max-width: 100%;
  }
}

// Custom dialog styling
:deep(.welcome-dialog) {
  border-radius: 1.25rem;
  overflow: hidden;
}
</style>
